<template>
  <div class="box">
    <div class="boxTop">
      <div class="head">
        <div class="headBox">
          <div class="headLeft">
            <img src="../../assets/images/logo.png" alt="">
          </div>
          <div class="headCenter">
          </div>
          <div class="headRight">
            <div class=headRightTel>
              官方电话：400-999-6541
            </div>
            <div class="headRightLogin" >
              <div class="headRightDl" @click="to('/login')" v-show="info">机构登录</div>
              <div class="headRightDl" @click="dialogFormVisible = true"  v-show="info">免费申请</div>
              <div class="headRightDl" @click="toSy"  v-show="!info">进入系统</div>
              <a :href="code"> <img src="../../assets/images/anniu.png"  alt=""></a>
            </div>
          </div>
        </div>
      </div>
      <div class="boxCenter">

        <div class="boxCenterInput">
          <div class="boxCenterInputBox">
            <input type="text" v-model="search" placeholder="输入你想写的内容">
            <div class="boxCenterInputBtn" @click="znXiez"><img src="../../assets/images/search.png" alt="">智能写作</div>
          </div>
        </div>
      </div>
    </div>
    <div class="desc-tab">
      <div class="flex align-center justify-between" style="width: 1200px;padding-top: 325px;margin: 0 auto">
        <div class="tab-item" :class="{'active':tab === 1}" @mouseover="tab = 1">
          <img src="../../assets/images/tab1.png" alt="">
          <h2>日常工作文案不规范</h2>
          <p>社会组织日常登记、年检、换届、评估等文件工作，没有统一的规范模板，导致信息表格填报出现错误，给年检、换届、评估等工作造成麻烦</p>
          <div></div>
        </div>
        <div class="tab-item" :class="{'active':tab === 2}" @mouseover="tab = 2">
          <img src="../../assets/images/tab2.png" alt="">
          <h2>日常项目文案不规范</h2>
          <p>社会组织项目相关的方案、合同、纪要、新闻稿、报告等文案，书写混乱、不符合要求，给项目结项带来影响</p>
          <div></div>
        </div>
        <div class="tab-item" :class="{'active':tab === 3}" @mouseover="tab = 3">
          <img src="../../assets/images/tab3.png" alt="">
          <h2>日常宣传文案不规范</h2>
          <p>社会组织宣传文案工作中词条内涵模糊、禁忌用词不了解等疏忽时有发生，给社会组织宣传工作带来危机</p>
          <div></div>
        </div>
      </div>
    </div>
    <div class="bg1"></div>
    <div class="bg2"></div>
    <div class="bg3"></div>
    <div class="bg4"></div>

    <div class="end">
      Copyright 益魔方
      <a href="https://beian.miit.gov.cn/" target="_blank" style="color: rgb(255, 255, 255);">京ICP备15038897号-3</a>
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802038214" target="_blank" class="margin-lr-xs" style="color: rgb(255, 255, 255);">
        <img src="http://www.beian.gov.cn/img/new/gongan.png" alt="" style="vertical-align: text-top;">京公网安备11010802038214号</a>
      北京易魔方科技集团有限公司  版权所有

    </div>
    <el-dialog
      title=""
      :visible.sync="dialogFormVisible"
      custom-class="shenqBox"
      center
    >
      <div class="imgs" style="width: 100%;padding-bottom: 40px;text-align: center;">
        <img src="../../assets/images/yishubao.png" alt="">
      </div>
      <el-form :model="formA" :rules="rules" ref="formA" class="demo-ruleForm">
        <el-form-item label="机构名称：" :label-width="formLabelWidth"  prop="name">
          <el-input v-model="formA.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系人：" :label-width="formLabelWidth" prop="ren">
          <el-input v-model="formA.ren" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" :label-width="formLabelWidth"  prop="tel">
          <el-input v-model="formA.tel" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" style="width: 100px;height: 40px;">取 消</el-button>
        <el-button type="primary" @click="shenq" style="width: 100px;height: 40px;margin-left: 40px;">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

  export default {

    name: "notLogin",
    data() {
      var validatePass = (rule, value, callback) => {
        let reg = /^1[3456789]\d{9}$/;
        if (value === '') {
          callback(new Error('请输入手机号'));
        } else if (!reg.test(value)) {
          callback(new Error('请输入正确的手机号'));
        } else {
          callback();
        }
      };
      return {
        tab:1,
        info: true,
        search: '',
        code:'https://www.emof.cn',
        dialogFormVisible: false,
        formLabelWidth: '120px',
        formA: {
          name: '',
          ren: '',
          tel: '',
        },
        rules:{
          name: [
            { required: true, message: '请输入机构名称', trigger: 'blur' }
          ],
          ren: [
            { required: true, message: '请输入联系人', trigger: 'blur' }
          ],
          tel: [
            { validator: validatePass, trigger: 'blur' }
          ],
        }
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {
      if (this.user) {
        this.info = false
        this.code = 'https://www.emof.cn/vw/tiaoz?code=' + this.user.emofUserTokenSafer + '&path=home'
      }
    },
    methods: {
      //免费申请
      shenq(){
        this.$refs.formA.validate((valid) => {
          var that = this
          console.log(valid)
          if (valid) {
            var xhr = new XMLHttpRequest();
            xhr.open('post', 'https://www.emof.cn/index.php/home/login/organizationApply' );
            xhr.setRequestHeader("Content-type","application/x-www-form-urlencoded");
            xhr.send( 'organizationName=' + this.formA.name +'&contactsPeople='+ this.formA.ren +'&contactsPhone='+this.formA.tel+'&sourceFrom=益书宝');
            xhr.onreadystatechange = function () {
              if (xhr.readyState === 4 && xhr.status === 200) {
                var error = JSON.parse(xhr.responseText);
                that.$messageSuccess(error.msg);
                this.dialogFormVisible = false
              }
            };
          }
        })


      },

      to(path) {
        this.$router.push(path)
      },
      // 跳转首页
      toSy() {
        if (!this.user) {
          this.$router.push({
            path: '/login',
            query: {
              rout: "/home"
            }
          })
        } else {
          this.$router.push("/home")
        }
      },
      // 跳转我的文章
      toWdWz() {
        if (!this.user) {
          this.$router.push({
            path: '/login',
            query: {
              rout: "/home/wdwzBanKuai"
            }
          })
        } else {
          this.$router.push("/home/wdwzBanKuai")
        }
      },
      // 跳转最新文章
      toZxwz() {
        if (!this.user) {
          this.$router.push({
            path: '/login',
            query: {
              rout: "/home/zxwzBanKuai"
            }
          })
        } else {
          this.$router.push("/home/zxwzBanKuai")
        }
      },
      // 跳转帮助中心
      toHsz() {
        if (!this.user) {
          this.$router.push({
            path: '/login',
            query: {
              rout: "/home/hszBanKuai"
            }
          })
        } else {
          this.$router.push("/home/hszBanKuai")
        }
      },
      // 跳转智能成稿
      toZn() {
        if (!this.user) {
          this.$router.push({
            path: '/login',
            query: {
              rout: "/home/zncgBanKuai"
            }
          })
        } else {
          this.$router.push("/home/zncgBanKuai")
        }
      },
      // 跳转模板成稿
      toMb() {
        if (!this.user) {
          this.$router.push({
            path: '/login',
            query: {
              rout: "/home/mbzxBanKuai/zyMuBan"
            }
          })
        } else {
          this.$router.push("/home/mbzxBanKuai/zyMuBan")
        }
      },
      // 智能写作
      znXiez() {
        if (!this.user) {
          this.$router.push({
            path: '/login',
            query: {
              rout: "/home/mbzxBanKuai/zyMuBan",
              zhiJieS: this.search
            }
          })
        } else {
          if (this.search === '') {
            this.$messageError("请输入搜索内容！");
            return false
          }
          this.$router.push({
            path: '/home/zncgBanKuai',
            query: {
              zhiJieS: this.search
            }
          })
        }
      }
    },
    watch: {}
  }
</script>

<style scoped lang="scss">
  .box {
    width: 100%;
    height: 100%;
    /*overflow-y: scroll;*/
    .boxTop {
      width: 100%;
      height: 840px;
      background: url("../../assets/images/redBgc.jpg") no-repeat;
      background-size: 100% 100%;

      .head {
        width: 1200px;
        height: 100px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .headBox {
          min-width: 1200px;
          width: 94%;
          margin: 0 auto;
          height: 70px;
          display: flex;
          justify-content: space-between;

          .headLeft {
            /*width: 90px;*/
            height: 70px;
            line-height: 70px;

            img {
              width: 520px;
              /*height: 46px;*/
              margin-top: 14px;
            }
          }

          .headCenter {
            height: 70px;
            padding-top: 10px;
            display: flex;
            justify-content: space-between;

            span {
              display: block;
              padding: 0 10px;
              margin: 20px 10px 0 0;
              text-align: center;
              height: 30px;
              font-size: 16px;
              line-height: 30px;
              color: #ffffff;
              cursor: pointer;
            }
          }

          .headRight {
            display: flex;
            justify-content: space-between;
            padding-top: 6px;

            .headRightTel {
              font-size: 16px;
              color: #ffffff;
              padding-left: 20px;
              height: 30px;
              line-height: 30px;
              margin:25px 0 20px;
              background: url("../../assets/images/phone.png") no-repeat left center;
              background-size: 16px 16px;
            }

            .headRightLogin {
              display: flex;
              justify-content: space-between;
              height: 30px;
              margin: 20px;

              div {
                height: 30px;
                line-height: 30px;
                font-size: 16px;
                color: #ffffff;
                cursor: pointer;
              }

              .headRightDl {
                width: 99px;
                height: 40px;
                text-align: center;
                line-height: 38px;
                font-size: 16px;
                color: #fff;
                margin: 0 5px ;
                border-radius: 20px;
                border: solid 1px #ffffff;
              }
              a{
                height: 40px;
                line-height: 40px;
                font-size: 16px;
                color: #fff;
                text-align: center;
                margin: 0 5px;
              }
            }
          }
        }
      }

      .boxCenter {
        min-width: 1200px;
        margin-top: 120px;

        .boxCenterTitle {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 790px;
          }
        }

        .boxCenterInput {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 577px;

          .boxCenterInputBox {
            width: 900px;
            height: 58px;
            background-color: #f4f6ff;
            border-radius: 29px;
            position: relative;

            input {
              width: 637px;
              height: 58px;
              background-color: #f4f6ff;
              border-radius: 29px;
              border: none;
              font-size: 18px;
              text-indent: 30px;
              padding-right: 110px;
            }

            .boxCenterInputBtn {
              position: absolute;
              top: 0;
              right: 0;
              width: 150px;
              height: 58px;
              display: flex;
              align-items: center;
              justify-content: center;
              background-image: linear-gradient(37deg,
                #ffb400 0%,
                #fc7802 100%),
              linear-gradient(
                  #ff9600,
                  #ff9600);
              background-blend-mode: normal,
              normal;
              box-shadow: -1px -2px 22px 0px rgba(0, 101, 206, 0.2);
              border-radius: 29px;
              font-size: 18px;
              cursor: pointer;
              img{
                margin-right: 5px;
              }
            }
          }
        }

        .boxBottom {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 60px;

          .boxBottomBox {
            width: 890px;
            height: 210px;
            display: flex;
            justify-content: space-between;

            .boxBottomBoxLeft {
              width: 371px;
              height: 209px;
              background-color: #ffffff;
              border-radius: 20px;
              cursor: pointer;

              .leftImg {
                width: 100%;
                height: 64px;
                display: flex;
                justify-content: center;
                margin-top: 50px;

                img {
                  width: 64px;
                  height: 64px;
                }
              }

              .leftTex {
                width: 100%;
                text-align: center;
                font-size: 26px;
                color: #333;
                margin-top: 20px;
              }
            }
          }
        }
      }
    }

    .boxFoot {
      width: 100%;
      display: flex;
      /*height: 400px;*/
      min-width: 1200px;
      background-color: #fff;
      /*background: url("../../assets/images/gai1_02.png") no-repeat;*/
      /*background-size: 100% auto;*/
      justify-content: center;

      .boxFootBox {
        width: 1200px;
        height: 199px;
        /*position: absolute;*/
        /*top: -60px;*/
        background-color: #ffffff;
        /*box-shadow: 0px 0px 21px 0px*/
        /*rgba(224, 0, 19, 0.16);*/
        /*border-radius: 10px;*/
        .boxFootBoxNav {
          width: 80px;
          margin-top: 50px;
          float: left;
          margin-left: 134px;

          .img {
            width: 80px;
            display: flex;
            justify-content: center;

            img {
              width: 54px;
              height: 54px;
            }
          }

          .tex {
            width: 100%;
            text-align: center;
            font-size: 20px;
            color: #333;
            margin-top: 20px;
          }
        }
      }
    }

    .footTwo {
      width: 100%;
      /*height: 500px;*/
      img {
        width: 100%;
        /*height: 100%;*/
      }
    }

    .footThree {
      width: 100%;
      height: 480px;
      background: url("../../assets/images/gaiBg_02.png") no-repeat;
      background-size: 100% 100%;

      .fttit {
        width: 100%;
        text-align: center;
        padding: 40px 0;

        img {
          width: 240px;
        }
      }

      .w {
        width: 1200px;
        margin: 0 auto;

        .zhiC {
          width: 1200px;
          /*margin-top: 120px;*/
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;

          .zcBox {
            width: 285px;
            /*height: 140px;*/
            border-radius: 4px;

            img {
              width: 100%;
              /*height: 100%;*/
            }
          }

          .zcBoxT {
            width: 386px;
            height: 140px;
            border-radius: 4px;
            margin-top: 14px;

            img {
              width: 100%;
              /*height: 100%;*/
            }
          }
        }
      }
    }

    .end {
      width: 100%;
      height: 60px;
      background-color: #0a2240;
      line-height: 60px;
      font-size: 14px;
      color: #fff;
      text-align: center;
    }
  }
  .desc-tab{
    height: 844px;
    background: url(../../assets/images/desc-tab.jpg) no-repeat center;
    .tab-item{
      width: 382px;
      height: 432px;
      padding: 68px 45px;
      background-color: #ffffff;
      box-shadow: 1px 2px 35px 15px
      rgba(158, 158, 158, 0.15);
      border-radius: 10px;
      &.active{
        background-color: #092240;
        box-shadow: 1px 2px 23px 1px
        rgba(24, 70, 124, 0.34);
        p{
          color: #fff;
        }
        div{
          background: url(../../assets/images/mores.png) no-repeat center;
        }
      }
      img{
        display: block;
        margin: 0 auto 20px;
      }
      h2{
        font-size: 28px;
        text-align: center;
        line-height: 38px;
        margin-bottom: 20px;
        color: #ff8900;
      }
      p{
        font-size: 16px;
        line-height: 32px;
        color: #657ba0;
        text-align: center;
        height: 128px;
      }
      div{
        width: 36px;
        height: 36px;
        margin: 20px auto;
        background: url(../../assets/images/more.png) no-repeat center;
      }
    }
  }
  .bg1 {
    height: 799px;
    background: url(../../assets/images/1.jpg) no-repeat center;
  }

  .bg2 {
    height: 564px;
    background: url(../../assets/images/2.jpg) no-repeat center;
  }

  .bg3 {
    height: 567px;
    background: url(../../assets/images/3.jpg) no-repeat center;
  }

  .bg4{
    height: 531px;
    background: url(../../assets/images/4.jpg) no-repeat center;
  }
</style>
